<template>
  <div class="shop-manage">
    <div class="no-data-box" v-if="!shopDataList.length">
      <p class="tit">您还没有添加任何管家</p>
      <div v-permission="'add'" @click="addShop">
        <img
          :src="require('@/assets/img/icon/add-shop-icon.png')"
          alt="添加管家"
        />
        <p>添加管家</p>
      </div>
    </div>

    <div class="table-list-block" v-if="shopDataList.length">
      <allot-manager-modal
        :shopId="curShop.id"
      ></allot-manager-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import editModal from "./editModal";
import moveHouseModal from "./moveHouseModal";
import allotManagerModal from "./allotManagerModal";
import RModal from "@/components/common/RModal";
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
export default {
  mixins: [tableMix],
  components: {
    editModal,
    RModal,
    moveHouseModal,
    allotManagerModal,
    RTable,
  },
  data() {
    return {
      pagination: { total: 0, pageIndex: 1, pageSize: 20 },
      tableColumns: [],
      moveStoreName: "",
      shopDataList: [],
      editModalShow: false,
      allotManageModalShow: false,
      moveHouseModalShow: false,
      currentShopId: null,
      promptShow: false,
      qrCode: "",
      curShop: null,
      shopTypeList: [
        { label: "民宿", value: 1 },
        { label: "酒店", value: 2 },
        { label: "公寓", value: 3 },
      ],
    };
  },
  created() {
    this.initTableColumn();
    this.initActiveShop();
    this.getQrCode();
    this.getQuery();
    this.$eventBus.on("change-shop", (store) => {
      this.currentShopId = store.id;
      this.curShop = store;
      this.pagination.pageIndex = 1;
      this.getQuery();
    });
  },
  beforeUnmount() {
    this.$eventBus.off("change-shop");
  },
  methods: {
    ...mapActions(["fetchData"]),

    // 初始化table
    initTableColumn() {
      this.tableColumns = [
        { prop: "storeName", label: "姓名" },
        { prop: "contact", label: "身份证号码" },
        { prop: "fullAddr", label: "手机号" },
        {
          prop: "operation",
          label: "操作",
          render: (row, index, column) => {
            return (
              <div class="operation">
                <el-button
                  style="margin-left: 10px"
                  style="padding: 0; margin-left:20px"
                  type="text"
                  v-permission="edit"
                  onClick={this.editShop.bind(this, row.id)}
                >
                  编辑
                </el-button>
                <el-button
                  style="margin-left: 10px"
                  style="padding: 0; margin-left:20px"
                  type="text"
                  v-permission="delete"
                  onClick={this.delShop.bind(this, row.id)}
                >
                  删除
                </el-button>
              </div>
            );
          },
        },
      ];
    },

    // 获取门店列表
    getQuery() {
      let url = "SHOP.GET_LIST";
      let params = {
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageIndex,
      };
      this.fetchData({
        url,
        method: "get",
        params,
      }).then((res) => {
        this.shopDataList = (res && res.data) || [];
      });
    },

    // 当前门店
    initActiveShop() {
      const curShop = localStorage.getItem("curShop");
      if (
        !curShop ||
        curShop === "" ||
        curShop === "undefined" ||
        curShop === "null"
      )
        return;
      this.curShop = JSON.parse(curShop);
    },

    // 获取小程序码
    getQrCode() {
      this.fetchData({
        url: "SYSTEM.PARAM.GET_LIST_WITHOUT_AUTH",
        method: "post",
        params: { name: "wx_qr_code" },
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        this.qrCode = (res && res[0] && res[0].value) || "";
      });
    },

    // 编辑门店
    editShop(id) {
      this.currentShopId = id;
      this.editModalShow = true;
    },

    // 删除门店
    delShop(id) {
      if (!id) return;
      this.$confirm("确定删除该门店吗？", { type: "warning" }).then((res) => {
        this.fetchData({
          url: "SHOP.DELETE",
          headers: { "Content-Type": "application/json" },
          method: "post",
          flag: true,
          params: [id],
        })
          .then((res) => {
            if (res && res.code === 200) {
              this.$message.success(res.msg || "操作成功！");
              this.$eventBus.emit("update-global-shop");
              this.getQuery();
            } else {
              this.$message.error(res.msg || "操作失败！");
            }
          })
          .catch(() => {
            this.$message.error("操作失败！");
          });
      });
    },

    // 设置房型
    toSetRoomType() {
      this.$router.push("./roomTypeManage");
    },

    // 切换门店
    checkShop() {},

    // 新增门店
    addShop() {
      this.fetchData({
        url: "MANAGER.GET_LIST",
        params: { pageNumber: 1, pageSize: 20 },
      }).then((res) => {
        if (res && +res.rowCount > 0) {
          this.currentShopId = null;
          this.editModalShow = true;
        } else {
          this.promptShow = true;
        }
      });
    },

    // 迁移房源
    moveHouseEv(id, storeName) {
      this.currentShopId = id;
      this.moveStoreName = storeName;
      this.moveHouseModalShow = true;
    },

    // 分配管家
    allotManageEv() {
      this.currentShopId = this.curShop.id;
      this.allotManageModalShow = true;
    },

    // 关闭新增编辑弹框
    closeModal($event) {
      this.editModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },

    // 关闭迁移房源弹框
    closeMoveHouseModal($event) {
      this.moveHouseModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },

    // 关闭分配管家弹框
    closeAllotManagerModal($event) {
      this.allotManageModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },
  },
};
</script>

<style lang="less">
.shop-manage {
  color: #000;
  height: 100%;
  font-size: 14px;
  padding: 15px;
  overflow-y: auto;
  .no-data-box {
    text-align: center;
    padding-top: 200px;
    .tit {
      font-size: 37px;
    }
    img {
      margin: 20px 0 10px 0;
      cursor: pointer;
    }
  }
  .shop-list-box {
    display: grid;
    grid-template-columns: repeat(4, 24%);
    // column-gap: 1%;
    gap: 15px 1%;
    .shop {
      border-radius: 12px;
      box-sizing: border-box;
      padding: 14px 20px;
      background-color: #fff;
      min-width: 230px;
      &.active-shop {
        border: 2px solid rgba(0, 192, 192, 1);
      }
      .head-operate {
        display: flex;
        justify-content: space-between;
        color: #00c0c0;
        .check-shop {
          padding: 2px 6px;
          border: 1px solid #00c0c0;
          cursor: pointer;
          border-radius: 8px;
        }
        .operate-btn {
          cursor: pointer;
          .del {
            padding-left: 10px;
            color: red;
          }
        }
      }
      .shop-info {
        .shop-name {
          margin: 15px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          align-content: center;
          .shop-label {
            display: inline-block;
            font-size: 12px;
            color: #fff;
            border-radius: 5px;
            width: 34px;
            padding: 4px;
            margin-right: 10px;
            &.shop-type1 {
              background-color: #52b82f;
            }
            &.shop-type2 {
              background-color: #f38626;
            }
            &.shop-type3 {
              background-color: #2699f3;
            }
          }
          .name {
            font-size: 18px;
            font-weight: bold;
          }
        }
        .contact,
        .address {
          color: #989898;
          :nth-last-child(1) {
            color: #000;
            margin: 15px 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .statistics {
          margin-top: 30px;
          margin-bottom: 15px;
        }
      }
      .footer-operate {
        text-align: center;
        .op-btn {
          display: inline-block;
          width: 125px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          background-color: #f66401;
          border-radius: 8px;
          &:nth-last-child(1) {
            background-color: #f7904b;
            margin-left: 20px;
          }
        }
      }
    }
    .add-shop {
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      cursor: pointer;
      min-width: 230px;
      min-height: 330px;
      img {
        margin-bottom: 10px;
      }
    }
  }
}
.el-dialog .el-dialog__body .prompt-content {
  text-align: center;
}
</style>